import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { create_organization_by_role_template } from 'liyu-pc-base/api/permission/user-manage';
import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export const btn_list: BtnListConfig = [];
export const config = {
  creatCol: [],
  updateCol: [],
};
export const head_btn_list: HeadBtnListConfig = [
  {
    name: '添加账套',
    type: 'dropdown',
    is_show: true,
    clazz: 'primary',
    cb: () => {
      const editModal = reactive({
        visible: true,
        title: '新建账套',
        loading: false,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '账套名称',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              maxlength: 100,
              defaultValue: '',
              placeholder: '请填组织名称',
            },

            {
              type: 'remoteselect',
              name: 'role_org_id',
              label: '权限模板',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'id',
              placeholder: '请填权限模板',
              datasourceType: 'remote',
              mode: 'default',
              modalType: 'select-org-id',
            },
          ],
          rules: {
            name: [{ required: true, message: '请输入账套名称' }],
            role_org_id: [{ required: true, message: '请选择权限模板' }],
          },
          model: reactive({
            name: '',
            role_org_id: '',
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_organization_by_role_template({
              ...payload,
            })
              .then(() => {
                message.success('创建新账套成功');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
